import React from "react"
import { Button } from "reactstrap"
import { CONTENT_TYPE_META } from "helpers/mustReadStatus"

const audienceChips = (row, companiesById) => {
  if (row.audienceAll) return [{ key: "all", label: "All users" }]
  return row.companyIds.map((id) => {
    const c = companiesById.get(id)
    if (!c) return { key: id, label: "Unknown company" }
    if (c.isPublic) return { key: id, label: "Public" }
    if (c.isDistributor) return { key: id, label: "Distributors" }
    return { key: id, label: c.name }
  })
}

const stagedTag = (row, original) => {
  if (row.tempId) return "New"
  if (row.retired) return "Retiring"
  if (!original) return null
  const changed =
    row.contentChanged ||
    row.title !== original.title ||
    (row.description || null) !== (original.description || null) ||
    row.audienceAll !== original.audienceAll ||
    [...row.companyIds].sort().join() !== [...original.companyIds].sort().join()
  return changed ? "Edited" : null
}

const MustReadItemList = ({ rows, server, companiesById, onEdit, onRetire, onRestore, onMove, onHistory }) => {
  const serverByKey = new Map(server.map((r) => [r.key, r]))
  const versionOf = (row) => row.versionNumber

  if (rows.length === 0) {
    return <div className="p-4 text-muted">No Onboarding resources yet. Add one to get started.</div>
  }

  return (
    <ul className="list-unstyled m-0">
      {rows.map((row, index) => {
        const tag = stagedTag(row, serverByKey.get(row.key))
        const type = CONTENT_TYPE_META[row.contentType] || CONTENT_TYPE_META.pdf
        return (
          <li key={row.key} className={`mr-row ${tag ? "mr-row--staged" : ""}`} style={row.retired ? { opacity: 0.55 } : undefined}>
            <div className="d-flex flex-column">
              <Button color="link" size="sm" className="p-0" disabled={index === 0} onClick={() => onMove(index, index - 1)} aria-label={`Move ${row.title} up`}>
                <i className="bx bx-chevron-up" />
              </Button>
              <Button color="link" size="sm" className="p-0" disabled={index === rows.length - 1} onClick={() => onMove(index, index + 1)} aria-label={`Move ${row.title} down`}>
                <i className="bx bx-chevron-down" />
              </Button>
            </div>
            <i className={`bx ${type.icon} mr-row__type`} aria-label={type.label} />
            <div className="mr-row__body">
              <p className="mr-row__title">
                {row.title} {tag && <span className="mr-tag ms-1">{tag}</span>}
              </p>
              <p className="mr-row__meta">
                {type.label}
                {versionOf(row) ? ` · v${versionOf(row)}` : ""}
                {row.documentName ? ` · ${row.documentName}` : ""}
              </p>
              <div className="d-flex flex-wrap gap-1 mt-1">
                {audienceChips(row, companiesById).map((chip) => (
                  <span key={chip.key} className="badge bg-light text-dark border">{chip.label}</span>
                ))}
              </div>
            </div>
            {!row.tempId && (
              <span className="text-muted small text-nowrap">
                {row.counts.reviewed} / {row.counts.applicable} reviewed
              </span>
            )}
            <div className="d-flex gap-2">
              {!row.tempId && (
                <Button size="sm" outline color="secondary" onClick={() => onHistory(row)} aria-label={`Version history ${row.title}`}>History</Button>
              )}
              {row.retired ? (
                <Button size="sm" outline color="secondary" onClick={() => onRestore(row.key)}>Undo</Button>
              ) : (
                <>
                  <Button size="sm" outline color="primary" onClick={() => onEdit(row)} aria-label={`Edit ${row.title}`}>Edit</Button>
                  <Button size="sm" outline color="danger" onClick={() => onRetire(row.key)} aria-label={`Retire ${row.title}`}>Retire</Button>
                </>
              )}
            </div>
          </li>
        )
      })}
    </ul>
  )
}

export default MustReadItemList
